/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface EuAiActRiskClass
 */
export interface EuAiActRiskClass {
  /**
   *
   * @type {number}
   * @memberof EuAiActRiskClass
   */
  toBeAssessed: number;
  /**
   *
   * @type {number}
   * @memberof EuAiActRiskClass
   */
  minimalRisk: number;
  /**
   *
   * @type {number}
   * @memberof EuAiActRiskClass
   */
  limitedRisk: number;
  /**
   *
   * @type {number}
   * @memberof EuAiActRiskClass
   */
  highRisk: number;
  /**
   *
   * @type {number}
   * @memberof EuAiActRiskClass
   */
  prohibitedVeryHighRisk: number;
}

/**
 * Check if a given object implements the EuAiActRiskClass interface.
 */
export function instanceOfEuAiActRiskClass(value: object): value is EuAiActRiskClass {
  if (!('toBeAssessed' in value) || value['toBeAssessed'] === undefined) return false;
  if (!('minimalRisk' in value) || value['minimalRisk'] === undefined) return false;
  if (!('limitedRisk' in value) || value['limitedRisk'] === undefined) return false;
  if (!('highRisk' in value) || value['highRisk'] === undefined) return false;
  if (!('prohibitedVeryHighRisk' in value) || value['prohibitedVeryHighRisk'] === undefined) return false;
  return true;
}

export function EuAiActRiskClassFromJSON(json: any): EuAiActRiskClass {
  return EuAiActRiskClassFromJSONTyped(json, false);
}

export function EuAiActRiskClassFromJSONTyped(json: any, ignoreDiscriminator: boolean): EuAiActRiskClass {
  if (json == null) {
    return json;
  }
  return {
    toBeAssessed: json['to be assessed'],
    minimalRisk: json['minimal risk'],
    limitedRisk: json['limited risk'],
    highRisk: json['high risk'],
    prohibitedVeryHighRisk: json['prohibited / very high risk'],
  };
}

export function EuAiActRiskClassToJSON(value?: EuAiActRiskClass | null): any {
  if (value == null) {
    return value;
  }
  return {
    'to be assessed': value['toBeAssessed'],
    'minimal risk': value['minimalRisk'],
    'limited risk': value['limitedRisk'],
    'high risk': value['highRisk'],
    'prohibited / very high risk': value['prohibitedVeryHighRisk'],
  };
}
